var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVorgesetzt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    space: "preserve",
    serif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19502,0,0,1,1.17207,-5.5382)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.099,
    y: 346.488,
    width: 309.323,
    height: 128.169,
    style: {
      fill: "rgb(153,153,153)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.623005,0,0,1.44726,-103.012,-59.4054)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.705,
    y: 41.047,
    width: 84.467,
    height: 298.069,
    style: {
      fill: "rgb(50,63,78)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.68648e-17,0.765361,-1,6.12323e-17,456.468,214.862)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.682,
    y: 326.116,
    width: 103.583,
    height: 13,
    style: {
      fill: "rgb(50,63,78)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVorgesetzt);
export default __webpack_public_path__ + "static/media/vorgesetzt.2d800da7cd5420936cb9b351de12e25e.svg";
export { ForwardRef as ReactComponent };